/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Actions for the container.
 */
import {
  NOTIFY,
  FETCH_DATA,
  FETCH_COMPLETE
} from './types';
import { customers, customsHouses, users} from '../../services';

const services = { customsHouses };

export const fetchData = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
          if(typeof(result.response) === "undefined"){
            onDataLoaded(dispatch, [
                { path, value: result._embedded.customsHouses },
            ]);
          }else {
            showErrorMessage(dispatch, result.response.data.message)
          }
        });
    };
};

const onDataLoaded = (dispatch, targets) => {
    dispatch({
        type: NOTIFY,
        payload: { op: 'multiUpdate', targets }
    });
};

export const notify = (payload) => {
    return {
        type: NOTIFY,
        payload
    };
};

export const saveCustomsHouse = (newCustomsHouse) => {
  newCustomsHouse={
    ...newCustomsHouse,
    ownOffice: newCustomsHouse.ownOffice === "YES"? true : false
  }
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["customsHouses"].post("customsHouses?projection=forListing", newCustomsHouse).then(result => {
            if(typeof(result.response) === "undefined"){
              //Cierro modal de formulario
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              //Añado una nueva aduana a la lista del estado
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'add', path: 'customsHouses', value: result }});
            }else {
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const editCustomsHouse = (newCustomsHouse, index) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["customsHouses"].put("customsHouses/" + newCustomsHouse.id, newCustomsHouse, {projection: 'forListing'}).then(result => {
            if(typeof(result.response) === "undefined"){
              //Cierro modal de formulario
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              //Añado una nueva aduana a la lista del estado
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'updateItem', path: 'customsHouses', value: {index, value: { ...result, id:newCustomsHouse.id} }}});
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const deleteCustomsHouse = (customsHouseToRemove, index) =>{
  return (dispatch) => {
      dispatch({ type: FETCH_DATA });
      return services['customsHouses'].Delete('customsHouses/'+ customsHouseToRemove.id).then(result => {
          onDataLoaded(dispatch, [
              { path: 'isLoading', value: false },
              { path: 'showNotification', value: true},
              { path: 'showMessage', value: result.message },
              { path: 'notificationColor', value: result.color }
         ]);
         if(result.color=== '#04B404'){
           dispatch({ type: FETCH_COMPLETE, payload: { op: 'remove', path: 'customsHouses', value: index } });
         }
      });
  };
};

const showErrorMessage = (dispatch, message)  => {
  onDataLoaded(dispatch, [
      { path: 'isLoading', value: false },
      { path: 'showNotification', value: true},
      { path: 'showMessage', value:   message },
      { path: 'notificationColor', value: 'red' }
  ]);
};



// WEBPACK FOOTER //
// ./containers/aduanas/actions.js